import React from "react";
import { Tabs, TabList, Tab, TabContent } from "@emisgroup/ui-tabs";

export interface TabListProps {
  value: string;
  label: string;
  content?: React.ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  activeTab: string;
  tabsList: TabListProps[];
  onTabChange: (tab: string) => void;
}

/**
 * Responsible for rendering the tabs component
 * @returns tab element
 */
export const UITabs: React.FC<TabsProps> = (props: TabsProps) => {

  const { activeTab, tabsList, onTabChange } = props;

  return (
    <div>
      <Tabs
        activationMode="manual"
        value={activeTab}
        onValueChange={onTabChange}
      >
        <TabList>
          {tabsList.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              disabled={tab.disabled}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
        <div>
          {tabsList.map((tab) => (
            <TabContent
              key={tab.value}
              value={tab.value}
            >
              {tab.content}
            </TabContent>
          ))}
        </div>
      </Tabs>
    </div>
  );
};
